module.exports = __webpack_public_path__ + "img/madnessBanner_460.f8d9b959.png";